import { DispatchType } from '../../../@types/redux-types'
import { getUser } from '../../../api/user/userApi'
import { getUserInitialCompletionSuccess } from '../../reducers/insertion/insertionFeature'
import { showMessage } from '../../reducers/message/messageFeature'
import NotLoggedInError from '../../../services/domain/errors/NotLoggedInError'
import { doSsoRedirect } from '../login/login'
import { getUserSuccess } from '../../reducers/user/userFeature'

export const getUserInitialCompletion = () => async (dispatch: DispatchType) => {
  try {
    const user = await getUser()
    dispatch(getUserInitialCompletionSuccess({ user: user }))
    dispatch(getUserSuccess({ user: user }))
    return true
  } catch (error) {
    if (error instanceof NotLoggedInError) {
      doSsoRedirect()
    } else {
      dispatch(showMessage({ message: 'unknown' }))
    }
    return false
  }
}
